import React from 'react';
import { Instagram, Linkedin, Heart, ExternalLink } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="py-24 bg-cream border-t border-neutral-100 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12 text-center md:text-left">
        {/* Left: Brand & Social */}
        <div className="space-y-6 flex-1">
          <div className="space-y-2">
            <h3 className="text-3xl font-black tracking-tighter uppercase">Vibe with AI</h3>
            <div className="flex items-center justify-center md:justify-start gap-2 group">
              <span className="text-[9px] font-black uppercase tracking-[0.4em] text-neutral-300">A</span>
              <a 
                href="https://labz.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[9px] font-black uppercase tracking-[0.4em] text-neutral-400 hover:text-terracotta transition-colors flex items-center gap-1"
              >
                Lab Z
                <ExternalLink size={8} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
              <span className="text-[9px] font-black uppercase tracking-[0.4em] text-neutral-300">Initiative</span>
            </div>
          </div>
          <div className="flex justify-center md:justify-start gap-8 text-neutral-400">
            <a 
              href="https://www.instagram.com/azards/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-charcoal transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a 
              href="https://www.linkedin.com/in/arthurzards/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-charcoal transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        {/* Center: Vibe Coded Credit */}
        <div className="flex-1 flex flex-col items-center justify-center space-y-2">
          <p className="text-[9px] font-black uppercase tracking-[0.5em] text-neutral-400 text-center leading-loose max-w-xs">
            Site is 100% Vibe Coded: Featuring Google AI Studio, GitHub, Vercel, Humans
          </p>
        </div>

        {/* Right: Copyright & Location */}
        <div className="flex-1 flex flex-col items-center md:items-end gap-3 text-neutral-400 text-[10px] tracking-[0.4em] font-black uppercase">
          <div className="flex items-center gap-2 mb-2 text-terracotta">
            <span>Where meaning takes shape</span>
            <Heart size={10} className="fill-terracotta" />
          </div>
          <span className="text-neutral-500">Vibe with AI © 2026</span>
          <span className="opacity-30">Naperville, IL / Global</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;